import { InputRef, Select } from 'antd';
import {
  MockSportCategoryProps,
  mockMoreSportsCategory,
  mockSportCategory,
  sportHaveDraw,
} from 'api/mockSportCategory';
import { useAppDispatch, useAppSelector, useAppTranslation } from 'app/hooks';
import turbo_icon from 'assets/icons/turbo_icon.png';
import Typo from 'consts/typography';
import React, { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { platformStates } from 'redux/platformSlice';
import { checkMoreSportActive, uniqueId } from 'utils/commonUtils';
import { getLocalStorage, setLocalStorage } from 'utils/sessionStorage';
import { selectCurrentConverter, setCurrentConverter, setCurrentTurbo } from '../homeSlice';
import { isValidAmount } from './Modals/WithdrawModal';
import { Switch } from 'antd';
import { Tooltip } from 'antd';
import TurboButton from 'components/Commons/TurboButton';
import { IoInformationCircleOutline } from 'react-icons/io5';
const { Option } = Select;

interface LeagueTabProps {
  category: string;
  hardTab?: string;
  tab?: string | null;
}

const turbos = [
  {
    value: 'none',
    label: <img src={turbo_icon} alt="turbo" className="dropdown-logo" />,
  },
  {
    value: '50',
    label: '50$',
  },
  {
    value: '100',
    label: '100$',
  },
  {
    value: '200',
    label: '200$',
  },
];

const LeagueTab: React.FunctionComponent<LeagueTabProps> = ({ category, hardTab, tab = null }) => {
  // const [tabList, setTabList] = useState<MockSportCategoryProps[]>([]);
  const [tabList, setTabList] = useState<{ value: string; label: string }[]>([]);
  const [selectedValue, setSelectedValue] = useState<string>('');
  const [searchParams, setSearchParams] = useSearchParams();
  const { isPhone, isTablet, isLaptop } = useAppSelector(platformStates);
  const [customTurbo, setCustomTurbo] = useState<string>('');
  const dispatch = useAppDispatch();
  const inputRef = useRef<InputRef>(null);
  const t = useAppTranslation();
  const currentConverter = useAppSelector(selectCurrentConverter);
  const platform = useAppSelector(platformStates);
  const isMoreSportsActive: boolean = useMemo(() => {
    return checkMoreSportActive(category);
  }, [category]);
  const [items, setItems] = useState<any[]>(turbos);

  useEffect(() => {
    if (getLocalStorage('customTurbo')) {
      setItems(
        JSON.parse(getLocalStorage('customTurbo') || '[]').map((turbo: any) =>
          turbo.value === 'none'
            ? {
                value: turbo.value,
                label: <img src={turbo_icon} alt="turbo" className="dropdown-logo" />,
              }
            : turbo,
        ),
      );
    }
  }, []);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const regex = /^(?!.*\..*\..*)(?=.*\d)(?!.*\.\d{3,})(?!.{11,}$)[\d.]{0,10}$/;
    const value = event.target.value;

    if ((regex.test(value) && isValidAmount(value)) || value === '') {
      setCustomTurbo(value);
    }
  };

  const addItem = (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
    e.preventDefault();
    if (!customTurbo) return;
    if (items.some((x) => x.value === customTurbo)) return;
    const newItems = [...items, { value: customTurbo, label: `${customTurbo}$` }].sort(
      (a, b) => Number(a.value) - Number(b.value),
    );
    setItems(newItems);
    setCustomTurbo('');
    setLocalStorage(
      'customTurbo',
      JSON.stringify(
        newItems.map((turbo: any) =>
          turbo.value === 'none'
            ? {
                value: 'none',
                label: 'none',
              }
            : turbo,
        ),
      ),
    );
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  const handleChangeTurbo = (value: string) => {
    dispatch(setCurrentTurbo(value));
    setLocalStorage('turbo', value);
  };

  useEffect(() => {
    const categories = mockSportCategory.filter((c) => c.sportActivity.toLowerCase() === category);
    const moreSportCategories = mockMoreSportsCategory.filter(
      (c) => c.sportActivity.toLowerCase() === category,
    );
    const tab = categories.length
      ? categories
          .filter((item) => item.sportTitle !== 'Futures')
          .map((item) => ({
            value: item.sportTitle,
            label: item.sportTitleShort,
          }))
      : moreSportCategories.map((item) => ({
          value: item.sportTitle,
          label: item.sportTitleShort,
        }));
    setTabList(tab);
    if (tab.length > 0) {
      setSelectedValue(searchParams.get('tab') || tab[0].value);
    }
  }, [category, searchParams.get('tab')]);

  // const onChangeTab = (tab: MockSportCategoryProps) => {
  //   setSearchParams({
  //     category: searchParams.get('category')?.toString() || '',
  //     tab: tab.sportTitle,
  //   });
  // };

  const onChangeTab = (value: string) => {
    setSearchParams({
      category: searchParams.get('category')?.toString() || '',
      tab: value,
    });
    setSelectedValue(value);
  };

  const isSingle = useMemo(() => {
    if (sportHaveDraw.includes(category)) {
      return false;
    }
    return isMoreSportsActive;
  }, [category, isMoreSportsActive]);

  const handleChangeConverter = (checked: boolean) => {
    if (checked) {
      dispatch(setCurrentConverter('decimal'));
      setLocalStorage('converter', 'decimal');
    } else {
      dispatch(setCurrentConverter('american'));
      setLocalStorage('converter', 'american');
    }
  };

  return (
    <div className={`header-league ${isSingle ? 'pr-5' : ''}`}>
      <div className="league-tab">
        <div className="league-tab">
          {hardTab ? (
            <>
              <div key={uniqueId()} className={`league-tab-item active`}>
                <span
                  className={`primary-text-color ${
                    isPhone ? Typo.p7 : isTablet ? Typo.p5 : Typo.p6
                  }`}
                >
                  {hardTab}
                </span>
              </div>
            </>
          ) : (
            <Fragment>
              <Select
                options={tabList}
                value={selectedValue}
                onChange={onChangeTab}
                size="small"
                style={{ width: 'max-content' }}
                dropdownClassName="league-tab-dropdown"
              />
              <Switch
                checkedChildren="Odds"
                unCheckedChildren="Odds"
                checked={currentConverter === 'decimal'}
                onChange={handleChangeConverter}
                size="small"
                className="custom-switch"
              />
            </Fragment>
          )}
        </div>
        {isPhone || isTablet ? (
          <>
            <TurboButton classes={tab === 'Futures' ? 'mr-3' : ''} />
            <Tooltip
              title={
                <>
                  {t('tooltip.doubleBet')} <strong>{t('tooltip.finalNotice')}</strong>
                </>
              }
              placement="rightTop"
              showArrow={false}
              trigger={['click', 'touch']}
            >
              <IoInformationCircleOutline
                className="w-6 h-6 grey-text-color"
                style={{ marginLeft: '5px', alignSelf: 'center' }}
              />
            </Tooltip>
          </>
        ) : (
          <Tooltip
            title={
              <>
                {t('tooltip.doubleBet')} <strong>{t('tooltip.finalNotice')}</strong>
              </>
            }
            arrowPointAtCenter
            placement="rightTop"
          >
            <span style={{ marginTop: 3 }}>
              <TurboButton classes={tab === 'Futures' ? 'mr-3' : ''} />
            </span>
          </Tooltip>
        )}
      </div>

      {tab !== 'Futures' && (
        <div
          className={`league__header-columm league__header-columm${
            isSingle ? '--single' : '--main'
          }`}
        >
          <div
            className={`league__header-columm__group league__header-columm__group${
              isSingle ? '--single' : '--main'
            }`}
          >
            {!isSingle && (
              <span
                className={`primary-text-color ${isPhone ? Typo.p7 : isTablet ? Typo.p5 : Typo.p7}`}
              >
                {!sportHaveDraw.includes(category) ? 'SPREAD' : 'HOME'}
              </span>
            )}
            <span
              className={`primary-text-color ${isPhone ? Typo.p7 : isTablet ? Typo.p5 : Typo.p7}`}
            >
              {!sportHaveDraw.includes(category) ? 'MONEY' : 'TIE'}
            </span>
            {!isSingle && (
              <span
                className={`primary-text-color ${isPhone ? Typo.p7 : isTablet ? Typo.p5 : Typo.p7}`}
              >
                {!sportHaveDraw.includes(category) ? 'TOTAL' : 'AWAY'}
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LeagueTab;
